<div class="row mb-2">
  <div class="col ps-0">
    <div class="row">
      <h4 class="mb-2 py-1 font-header-1">Roles and Responsibilities</h4>
    </div>
    <div widget class="card border-0 box-shadow">
      <div class="card-header transparent text-muted">
        <div class="row w-100">
          <div class="col-lg-8">

          </div>
          <div class="col-lg-4"
            *ngIf="global.globalAgencyId != '00000000-0000-0000-0000-000000000000' && global.globalAgencyId != ''&& global.globalAgencyId != undefined && global.agencyCode== 'SUPERADMIN'">
            <div class="row float-start ms-2">

              <div class="col-lg-6">
                <div class="row me-3">
                  <div class="d-inline-flex">
                    <input [(ngModel)]="RoleType" (ngModelChange)="RoleTypeChange()" type="radio" id="Internal"
                      name="RoleType" value="Internal" class="mt-1 ms-1">&nbsp;
                    <label for="SuperAdminRole" class="mt-1">Internal</label>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="row ms-2">
                  <div class="d-inline-flex">
                    <input [(ngModel)]="RoleType" (ngModelChange)="RoleTypeChange()" type="radio" id="Global"
                      name="RoleType" value="Global" class="mt-1 ms-1">&nbsp;
                    <label for="EvvRole" class="mt-1">AgencyAdmin</label>
                  </div>

                </div>
              </div>


            </div>
          </div>

          <div class="col-lg-4"
            *ngIf="(global.globalAgencyId == '00000000-0000-0000-0000-000000000000' || global.globalAgencyId == '' || global.globalAgencyId == undefined) && global.agencyCode== 'SUPERADMIN'">
            <div class="row float-start ms-2">

              <div class="col-lg-6">
                <div class="row me-3">
                  <div class="d-inline-flex">
                    <input [(ngModel)]="RoleType" (ngModelChange)="RoleTypeChange()" type="radio" id="SuperAdminRole"
                      name="RoleType" value="SuperAdminRole" class="mt-1 ms-1">&nbsp;
                    <label for="SuperAdminRole" class="mt-1">SuperAdminRoles</label>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="row ms-2">
                  <div class="d-inline-flex">
                    <input [(ngModel)]="RoleType" (ngModelChange)="RoleTypeChange()" type="radio" id="EvvRole"
                      name="RoleType" value="Agencyadmin" class="mt-1 ms-1">&nbsp;
                    <label for="EvvRole" class="mt-1">Agency Admin</label>
                  </div>

                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2 mb-2">
        <div class="col text-end">
          <button type="button" class="btn blue-btn btn-sm me-4" data-bs-toggle="modal" data-bs-target="#roleadd"
            (click)="Addrole()">New Role</button>
        </div>
      </div>
      <div class="row mt-1 ms-1">
        <div class="table-responsive border-0 table-sm  tableoverflow">
          <div class="table-data-bs-wrapper">
            <table class="table table-fixed" mdbTable>

              <thead class="text-primary ">
                <tr class="table-borderless text-center">
                  <th style="background-color:#502189;color: white;">Menu</th>
                  <th *ngFor="let s of rolePermisssionList?.roleMenu; let id = index" class="text-center textcolor"
                    style="background-color:#502189;color: white;">
                    <button class="btn btn-delete-table text-center" data-bs-toggle="modal"
                      data-bs-target="#deleterolemodal" (click)="deleteRoleSelected(s)"><i
                        class="fa fa-trash"></i></button> &nbsp;
                    {{s?.roleHeading.split('?')[0]}}&nbsp;
                    <input type="checkbox" class="checkbox checkbox-primary styled" [(ngModel)]="s.isRoleEnabled"
                      (change)="SaveRoleBasedMenu(s)">
                  </th>

                </tr>
              </thead>

              <tbody class="overflow-y">
                <tr class="table-borderless" *ngFor="let item of rolePermisssionList?.rolePermissiondata;let i=index"
                  style="border-bottom: 1px solid gray;">
                  <td>
                    <span *ngIf="!item.isSubMenu && !item.isFunctionMenu" class="textcolor"><b
                        style="color: darkblue">{{item.menuName}}</b></span>
                    <span *ngIf="item.isSubMenu && !item.isFunctionMenu"><b
                        style="color: black">{{item.menuName}}</b></span>
                    <span *ngIf="!item.isSubMenu && item.isFunctionMenu"><b
                        style="color: black">-{{item.menuName}}</b></span>
                  </td>
                  <td *ngFor="let s of item?.rolePermissionMappingData" class="text-center"
                    title="{{s.loginRole.split('?')[0]}}">
                    <input type="checkbox" [(ngModel)]="s.isEnabled" (change)="SaveMenuFuncPermission(s)">
                  </td>

                </tr>
              </tbody>

            </table>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- New Role -->
<span id="OpenModal2" data-bs-target="#roleadd" data-bs-toggle="modal"></span>
<div class="modal fade" id="roleadd" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
  data-backdrop="static">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">New Role</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-4">
            <label>Role Name </label>
          </div>
          <div class="col-lg-8">
            <input type="text" name="role" id="role" class="form-control" [(ngModel)]="headerName" />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row  text-end">
          <div class="col-lg-8">
            <button class="btn blue-btn btn-sm me-1" type="button"
              [disabled]="headerName==null || headerName==undefined || headerName=='' || isSaveUrUpdateBoolean"
              (click)="addroles(headerName);">Save & Close</button>
          </div>
          <div class="col-lg-4">
            <button class="btn blue-btn btn-sm" type="button" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Delete Modal -->
<span id="deleterolemodalopen" data-bs-target="#deleterolemodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="deleterolemodal" data-backdrop="static">
  <div class="modal-dialog delete-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header">Delete Role</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-12">
            <label>Do you want to delete this role ?</label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="deleteRole()">Delete</button>
        <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>